<template>
    <div>
        <template v-if="Menu != null">
            <hsc-menu-item @click="clickMenu"
                :label="Menu.format != undefined && typeof(Menu.format) === 'function' ? Menu.format(Menu.label) : Menu.label"
                           :class="'chartMenu' + (selected == null ? '' : (selected ? ' border rounded-pill border-secondary' : ''))"
                           :keybind="(selected ? '✓' : '')">
                <div slot="body" class="m-0 p-0 w-100" @mousedown.stop  v-if="Menu.formType == 'input'">
                    <b-row class="m-0 p-0 w-100" style="min-width: 10rem;">
                        <b-col cols="6" class="m-0 p-0 py-1">
                            <label class="m-0 p-0" for="input-small">{{ Menu.format != undefined && typeof(Menu.format) === 'function' ?
                                Menu.format(Menu.label) : Menu.label }} :</label>
                        </b-col>
                        <b-col cols="6" class="m-0 pl-1 p-0">
                            <b-form-input type="number" id="input-small" size="sm" v-model="imputValue" />
                        </b-col>
                    </b-row>
                </div>

                <template v-if="Menu.group != undefined && Menu.group.length > 0">
                    <b-row class="m-0 p-0"
                           :cols="Menu.group.length"
                           :style="Menu.group.length > 1 ? 'min-width: 20rem;' : ''">
                        <template v-for="(group, index) in Menu.group">
                            <b-col class="m-0 p-0 w-25" :class="index > 0 ? 'border-left' : ''">
                                <template v-if="group.label != undefined">
                                    <div class="m-1">
                                        <div class="text-gray-dark" size="sm"
                                             style="text-transform: uppercase; white-space:break-spaces;">
                                            <span v-html="withBrTags(group.format != undefined && typeof(group.format) === 'function' ?
                                                                        group.format(group.label) : group.label)"></span>
                                        </div>
                                    </div>
                                </template>
                                <template v-for="params in group.params">
                                    <template v-if="params != null">
                                        <chart-menu :Menu="params" :GroupMenu="group"
                                                    v-on="$listeners" :Configs="Configs"
                                                    :Results="Results"/>
                                    </template>
                                </template>
                            </b-col>
                        </template>
                    </b-row>
                </template>
            </hsc-menu-item>
        </template>
    </div>
</template>

<script lang="ts">
import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';

type MenuType = {
    id: string,
    menuType: string,
    index: number,
    label: string,
    format: any,
    //selected: boolean,
    configPath: ConfigPath[],
    formType: string,
    transform: {
        type: TransformMenuType,
        default: undefined,
        required: false
    },
    group: {
        type: GroupMenuType,
        default: undefined,
        required: false
    },
}

type ConfigPath = {
    path: any[],
    selectedValue: any
}

type GroupMenuType = {
    label: string,
    format: any,
    params: MenuType[]
}

type TransformMenuType = {
    type: string,
    'function': {
        type: boolean,
        required: false
    },
    config: {
        required: false
    },
    linkTitle: {
        type: boolean,
        required: false
    },
}

/** Composant affichant les différents niveaux du menu pour les graphiques */
@Component({
    name: 'chart-menu',
    components: {}
})
export default class Menu extends Vue {
    /** Option du graphique Apache EChart */
    @Prop({
        default: () => {
            option: {
            }
        }
    })
    public Results!: any;

    /** Menu et sous-menu */
    @Prop()
    public Menu: MenuType;

    /** Sous-menu */
    @Prop()
    public GroupMenu: GroupMenuType;

    /** Configuration du graphique */
    @Prop({
        default: () => {
            WorkParameters: {
            }
        }
    })
    public Configs: any;

    private selected: boolean = false;

    private imputValue: any = '';

    /**
     * Indique si le type de graphique dans la config est identique au nom du bouton.
     * @param type
     * @private
     */
    private getConfigWorkParameters(workParameters: string[]) {
        //console.debug("Menu - getConfigWorkParameters() - paramètre d'entrée", workParameters);
        if (this.Configs && ('WorkParameters' in this.Configs)) {
            let config = this.Configs.WorkParameters;
            for (let i = 0; i < workParameters.length; i++) {
                //console.debug('Menu - getConfigWorkParameters() - workParameters[i] : ', workParameters[i], config);
                if (config && ((workParameters[i]) in config)) {
                    config = config[workParameters[i]];
                } else {
                    //console.debug('Menu - changeConfig() - break');
                    config = undefined;
                    break;
                }
            }
            if (config == null || (Object.keys(config).length === 0 && config.constructor === Object))
                config = undefined;
            return config;
        } else {
            return undefined;
        }
    }

    /** Rafraichissement des données sur changement - CONFIGS */
    @Watch('Configs', {immediate: true, deep: true})
    public refreshConfigs() {
        this.selected = false;
        console.debug("Menu - refreshConfigs() - Menu.label", this.Menu.label);
        if (this.Configs && ('WorkParameters' in this.Configs) && this.Menu && ('configPath' in this.Menu)
            && this.Menu.configPath.length >= 1) {
            this.refechMenu();
        }
    }

    @Watch('imputValue')
    public changeImputValue(){
        this.clickMenu();
    }

    /** Rafraîchissement de la variable Selected et ImputValue*/
    private refechMenu() {
        let configPath = this.Menu.configPath.find(a => a.path.includes(this.Menu.id));
        console.log('',configPath);
        if (configPath && ('path' in configPath) && Array.isArray(configPath.path)) {
            let value = this.getConfigWorkParameters(configPath.path);
            if (typeof value == 'object') {
                this.selected = true;
                let key = Object.keys(value);
                for (let i = 0; i < key.length; i++) {
                    if ((key[i] in value) && (key[i] in configPath.selectedValue)) {
                        this.selected = this.selected && (value[key[i]] == configPath.selectedValue[key[i]]);
                    } else
                        this.selected = this.selected && false;
                }
            } else if (this.Menu.formType == 'input' && configPath.selectedValue == undefined) {
                this.imputValue = value;
            } else {
                this.selected = String(value) === String(configPath.selectedValue);
            }
        }
    }

    /** Click sur le menu */
    private clickMenu() {
        console.log('Menu.vue - clickMenu', this.Menu.menuType, this.Menu.index, this.Menu, this.GroupMenu);
        this.$emit('TransformMenuEvent', this.Menu.menuType, this.Menu.index, this.Menu, this.GroupMenu, this.imputValue);
    }

    /** Ajout de retour à la ligne */
    private withBrTags(name: string) {
        if (name.includes(' || ')) {
            let nameNiveau = [];
            let splitName = typeof (name.split) == 'function' ? name.split(' || ') : [name];
            nameNiveau.push(3);
            nameNiveau.push(4);

            let series = undefined;
            if (this && this.Results && ('option' in this.Results) && this.Results.option && ('series' in this.Results.option)) {
                series = [...this.Results.option.series];
            }

            if (series != undefined) {
                let niveau: { niveau: number, values: string[] }[] = Array(5).fill(0);
                niveau = niveau.map((v, i) => ({niveau: i, values: []}));

                if (series && series.length > 0) {
                    for (let i = 0; i < series.length; i++) {
                        let serie = [];
                        if (typeof (series[i]) == "object" && series[i].name) {
                            serie = typeof (series[i].name.split) == 'function' ? series[i].name.split(' || ') : [series[i]];

                            for (let j = 0; j < serie.length; j++) {
                                niveau[j].values.push(serie[j]);
                            }
                        } else if (typeof (series[i]) == "object" && !series[i].name && series[i].data) {
                            for (let j = 0; j < series[i].data.length; j++) {
                                if (typeof (series[i].data[j]) == "object" && series[i].data[j].name) {
                                    serie = typeof (series[i].data[j].name.split) == 'function' ? series[i].data[j].name.split(' || ') :
                                        [series[i].data[j]];
                                    for (let k = 0; k < serie.length; k++) {
                                        niveau[k].values.push(serie[k]);
                                    }
                                }
                            }
                        }
                    }
                }
                for (let i = 0; i < niveau.length; i++) {
                    if (niveau[i].values.length > 0) {
                        let values = niveau[i].values.filter((value, index, array) => array.indexOf(value) === index);
                        if (values.length > 1)
                            nameNiveau.push(niveau[i].niveau);
                    }
                }
                nameNiveau = nameNiveau.filter((value, index, array) => array.indexOf(value) === index).sort();

                if (nameNiveau.length > 0) {
                    let nameValue = '';
                    if (nameNiveau.find((e) => e < 3)) {
                        let index = nameNiveau.findIndex((e) => e == 0);
                        if (index >= 0)
                            nameNiveau.splice(index, 1);
                    }
                    for (let i = 0; i < nameNiveau.length; i++) {
                        if (splitName.length > nameNiveau[i]) {
                            nameValue += (nameValue == '' || splitName[nameNiveau[i]] == '' ? '' : '<br />') + splitName[nameNiveau[i]];
                        }
                    }
                    return nameValue;
                }
            }
        }

        if (typeof (name.replaceAll) == 'function') {
            return name.replaceAll(' || ', '<br />');
        } else {
            return name;
        }
    }
}
</script>

<style scoped>

:deep(.chartMenu > div > div:first-child) {
    padding: 0px !important;
    display: none !important;
}

:deep(.menuitem){
    border-radius: 50rem !important;
}

</style>